import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { Reveal } from "./shared";
import { FOUNDERS } from "../../lib/data";
import lahoo from "../../assets/lahoo.jpg";
import mihir from "../../assets/mihir.jpg";
import tejas from "../../assets/tejas.jpg";

const IMG = { "lahoo.jpg": lahoo, "mihir.jpg": mihir, "tejas.jpg": tejas };

export const Founders = () => (
  <>
    <section className="section" id="founders" data-testid="founders-section">
      <div className="container">
        <Reveal><p className="eyebrow">The Team</p></Reveal>
        <Reveal delay={0.05}>
          <h2 className="section-title" style={{ marginTop: 16 }}>
            Meet the <span className="accent">Founders</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="section-sub">
            Three Co-Founders. One Mission. Building stronger individuals through discipline, fitness, and martial arts.
          </p>
        </Reveal>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 26, marginTop: 56 }} className="programs-grid">
          {FOUNDERS.map((f, i) => (
            <Reveal key={f.name} delay={i * 0.1} y={50}>
              <motion.div whileHover={{ y: -10 }} transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                data-testid={`founder-card-${i}`} className="founder-card"
                style={{
                  background: "#fff", borderRadius: "var(--radius-lg)", padding: "40px 30px 34px",
                  boxShadow: "var(--shadow-soft)", border: "1px solid rgba(17,17,17,0.05)",
                  height: "100%", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center",
                  position: "relative", overflow: "hidden",
                }}>
                {/* soft brand backdrop */}
                <span aria-hidden="true" style={{ position: "absolute", top: -60, left: -60, width: 180, height: 180,
                  background: "radial-gradient(circle,rgba(193,18,31,0.08),transparent 70%)" }} />
                <span aria-hidden="true" style={{ position: "absolute", bottom: -60, right: -60, width: 200, height: 200,
                  background: "radial-gradient(circle,rgba(242,169,59,0.12),transparent 70%)" }} />

                {/* Portrait with brand ring */}
                <div className="founder-portrait" style={{
                  width: 200, height: 200, borderRadius: "50%", padding: 4,
                  background: "linear-gradient(135deg,var(--gold),var(--red))",
                  position: "relative", zIndex: 1,
                }}>
                  <img src={IMG[f.img]} alt={f.name} loading="lazy"
                    style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover",
                      objectPosition: "center 22%", background: "#fff", display: "block" }} />
                </div>

                <span style={{ marginTop: 22, fontSize: 11.5, letterSpacing: "0.18em", textTransform: "uppercase",
                  color: "var(--gold)", fontWeight: 800, position: "relative", zIndex: 1 }}>{f.role}</span>
                <h3 style={{ fontSize: 34, marginTop: 6, color: "var(--black)", position: "relative", zIndex: 1 }}>{f.name}</h3>

                <p style={{ marginTop: 14, fontSize: 14.5, color: "var(--muted)", lineHeight: 1.65,
                  position: "relative", zIndex: 1 }}>{f.bio}</p>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    {/* Why We Started VLA */}
    <section className="section alt" id="why-started" data-testid="why-started-section" style={{ paddingTop: 90, paddingBottom: 110 }}>
      <div className="container">
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1.4fr", gap: 60, alignItems: "center" }} className="about-grid">
          <div>
            <Reveal><p className="eyebrow">Our Story</p></Reveal>
            <Reveal delay={0.05}>
              <h2 className="section-title" style={{ marginTop: 16 }}>
                Why we started <span className="accent">VLA</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <div style={{ position: "relative", background: "#fff", borderRadius: "var(--radius-lg)", padding: "40px 44px",
              boxShadow: "var(--shadow-soft)", border: "1px solid rgba(17,17,17,0.05)" }}>
              <Quote size={40} style={{ color: "var(--gold)", opacity: 0.35, position: "absolute", top: 20, left: 24 }} />
              <p style={{ fontSize: "clamp(17px,1.8vw,20px)", color: "var(--text)", lineHeight: 1.7, position: "relative", zIndex: 1 }}>
                Victorious Lions Academy was founded with a simple vision — to <strong>empower individuals through martial arts, fitness, and discipline</strong>. By combining technical expertise, structured coaching, and a strong community, we aim to help every student build confidence, develop character, and unlock their full potential — both on and off the mat.
              </p>
              <div style={{ marginTop: 22, display: "flex", alignItems: "center", gap: 12 }}>
                <span style={{ width: 40, height: 4, borderRadius: 2, background: "var(--red)" }} />
                <span style={{ fontSize: 12.5, letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--muted)", fontWeight: 700 }}>
                  The VLA Founders
                </span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  </>
);
